import {
  PermissionResponse,
  ModuleNode,
  FlattenedPermission,
} from '@/models/permission';
import apiClient from '@/services/api-client';

export const fetchUserPermissions = async (): Promise<PermissionResponse> => {
  const res = await apiClient.get('/AwardManagement/master/user-permissions');
  return res.data;
};

export const flattenModules = (
  modules: ModuleNode[]
): FlattenedPermission[] => {
  const flattened: FlattenedPermission[] = [];

  const traverse = (node: ModuleNode) => {
    // Add node's own permissions
    if (node.permissions && node.permissions.length > 0) {
      node.permissions.forEach(perm => {
        flattened.push({
          code: perm.code,
          name: perm.name,
          permissionId: perm.permissionId,
          moduleId: node.moduleId,
          moduleName: node.moduleName,
        });
      });
    }

    // Recursively traverse children
    if (node.children && node.children.length > 0) {
      node.children.forEach(child => traverse(child));
    }
  };

  modules.forEach(module => traverse(module));
  return flattened;
};
